import { useSuspenseApiQuery } from '@mono-farmart-web/utilities/hooks/api';
import { useMemo } from 'react';
import moment from 'moment';
import {
	ChatHistoryResponse,
	FormattedChatHistoryItem,
} from '../interfaces/message';
import { APIS } from '../utils/apis';

function useChatHistory() {
	const { data: chatHistoryRaw } = useSuspenseApiQuery<ChatHistoryResponse>(
		['fetch_chat_history'],
		APIS.CHAT_HISTORY_LIST,
	);

	const chatHistory: FormattedChatHistoryItem[] | null = useMemo(() => {
		if (!chatHistoryRaw) return null;
		if (chatHistoryRaw.success === false) return null;
		if (!chatHistoryRaw.chats) return null;
		return chatHistoryRaw.chats.map(item => ({
			...item,
			last_updated_relative: moment.utc(item.last_updated).local().fromNow(),
		}));
	}, [chatHistoryRaw]);

	return { chatHistory };
}

export default useChatHistory;
